import { format } from "date-fns";
import { RowAction } from "@tiny/components/src/ListItemRow/ListItemRow.types";
import { SuppressionView } from "@tiny/api";
import { ChipColor } from "@tiny/components/src/Chip/Chip.types";
import {
  ActionTimeInfo,
  TimeAction,
} from "@tiny/components/src/ItemActionTimeInfo/ItemActionTimeInfo.types";
export const dateFormat = "dd MMM, yy - hh:mm a";

export function getTimeActionsInfo(
  mdUp: boolean,
  audience: SuppressionView,
  sortAction?: TimeAction
): ActionTimeInfo[] {
  const modifiedDate: ActionTimeInfo = {
    action: "Modified",
    timestamp: audience.updatedAt,
  };
  const actions: ActionTimeInfo[] = [];
  actions.push(modifiedDate);

  return actions;
}

export function toChipText(segmentType?: string): string | undefined {
  switch (segmentType) {
    case "LOCAL":
      return "Local";
    case "GLOBAL":
      return "Global";
    default:
      return undefined;
  }
}

export function toChipColor(segmentType?: string): ChipColor | undefined {
  switch (segmentType) {
    case "LOCAL":
      return "blue";
    case "GLOBAL":
      return "purple";
    default:
      return undefined;
  }
}

export function getRowActions(): RowAction[] {
  return [];
}

export const suppressionLabelMap: {
  [key: string]: string;
} = {
  EMAIL: "Email Address",
  MD5: "MD5 hash",
  SHA256: "SHA256 hash",
};

export const suppressionProcessingMap: {
  [key: string]: string;
} = {
  UPLOADED: "Uploaded",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  FAILURE: "Failure",
};

export async function downloadFileFromUrl(
  url: string,
  fileName: string
): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const contentDisposition =
    response.headers.get("content-disposition") || `fileName=${fileName}`;
  const downloadFileName = contentDisposition.split("fileName=")[1] || fileName;

  const link = document.createElement("a");
  const objectUrl = URL.createObjectURL(blob);
  link.href = objectUrl;
  link.download = downloadFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}

export function formatUploadedAt(createdAt?: number): string {
  if (!createdAt) {
    return "";
  }
  return format(new Date(createdAt), "dd MMM, yyyy - hh:mm a");
}
